import { DocFlowContext } from '../DocFlow.context'

function DocFlowProvider({ children, ...restProps }) {
  return <DocFlowContext value={restProps}>{children}</DocFlowContext>
}

export default DocFlowProvider
